export default {
  'clocks': [
    'clock0800_1000',
    'clock1000_1200',
    'clock1200_1400',
    'clock1400_1600',
    'clock1600_1800'
  ],
  'permanentRequiredFields': [
    'RequestInterest',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage',
    'Salutation',
  ],
  'requiredFields': {
    'default': [
      'Company',
      'PostalCode'
    ],
    'consulting': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'offersGeneral': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'offersInvestment': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'customer_serviceGeneral': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'customer_serviceBank': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'investor_relations': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'cooperation': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ]
  }
}
